import { useEffect, useState } from "react";
import { PRODUCT_OPTIONS } from "../config/products";
import { fetchUserProducts } from "../services/platformApi";

interface ProductOption {
  name: string;
  title: string;
}

export const useUserProducts = (user: unknown) => {
  const [products, setProducts] = useState<ProductOption[]>([]);
  const [productsLoading, setProductsLoading] = useState(false);

  useEffect(() => {
    const loadProducts = async () => {
      if (!user) {
        setProducts([]);
        setProductsLoading(false);
        return;
      }

      setProductsLoading(true);
      try {
        const userProducts = await fetchUserProducts(user);
        const mappedProducts = PRODUCT_OPTIONS.filter((product) =>
          userProducts.includes(product.name)
        );
        setProducts(mappedProducts);
      } catch (error) {
        console.error("Failed to fetch products", error);
      } finally {
        setProductsLoading(false);
      }
    };

    loadProducts();
  }, [user]);

  return { products, productsLoading };
};
